import { NgModule } from '@angular/core';
import { Ga4GgCartRemoveEntrySuccessEventBuilder } from './ga4-gg-cart-remove-entry-success-event.builder';

@NgModule({})
export class Ga4GgCartRemoveEntrySuccessEventModule {
  constructor(_ga4GgCartRemoveEntrySuccessEventBuilder: Ga4GgCartRemoveEntrySuccessEventBuilder) {}
}
